module.exports = __webpack_public_path__ + "e144c25e57e402857a0597da16d77d14.png";